import { SET_IS_DISPATCH_FEE_ACCEPTED } from 'actions';

export function setIsDispatchFeeAccepted(isDispatchFeeAccepted: boolean) {
  return { isDispatchFeeAccepted, type: SET_IS_DISPATCH_FEE_ACCEPTED };
}
